export default "__VITE_ASSET__C3dzkRaa__"